import React from 'react';
import StatsCard from './StatsCard';

const VisitStats = ({ title, stats }) => {
  return (
    <StatsCard title={title}>
      <div className="stats-numbers">
        <div className="stat-item">
          <span className="stat-label">Visites totales</span>
          <span className="stat-value">{stats.totalVisits}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Visiteurs uniques</span>
          <span className="stat-value">{stats.uniqueVisitors}</span>
        </div>
      </div>
    </StatsCard>
  );
};

export default VisitStats; 